import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { equals, map, toUpper } from "ramda";
import { useRemoveContentFromCollection } from "../../collections/collectionServices";
import { useDeleteModuleItems } from "../../modules/moduleServices";
import { useSnackAlert } from "../../../common/use-snackAlert";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import MediaDialog from "../../common/MediaDialog";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(5),
  },

  badge: {
    background: "rgba(125, 218, 252, 0.5)",
    borderRadius: 4,
    padding: "8px 12px",
    gap: 10,
    width: "auto",
    height: 32,
  },

  button: {
    width: "auto",
    textTransform: "capitalize",
  },

  mediaType: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.primary.main,
  },

  title: {
    color: theme.palette.primary.darker,
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
  },
}));

const PendingDialog = props => {
  const { open, content, parents, handleClose, handlePending } = props;
  const classes = useStyles();
  const { SnackAlert, showAlert } = useSnackAlert();

  const handleCloseClick = () => {
    handleClose();
  };

  const removeContentFromCollection = useRemoveContentFromCollection();
  const deleteModuleItems = useDeleteModuleItems();
  const removeParents = async () => {
    try {
      await Promise.all(
        map(async parent => {
          try {
            if (equals(parent.mediaType, "module")) {
              await deleteModuleItems.mutateAsync({
                id: parent.id,
                ids: [content.id],
              });
            }

            if (equals(parent.mediaType, "collection")) {
              await removeContentFromCollection.mutateAsync({
                collectionId: parent.id,
                contentIds: [content.id],
              });
            }
          } catch (err) {
            return err.message;
          }
        }, parents),
      );

      handleCloseClick();
      handlePending();
    } catch (err) {
      showAlert("error", [err.message]);
    }
  };

  return (
    <Fragment>
      <SnackAlert />

      <MediaDialog
        open={open}
        titleClassName={classes.title}
        title="Wait!"
        handleClose={handleCloseClick}
        content={
          removeContentFromCollection.isPending ||
          deleteModuleItems.isPending ? (
            <PanelLoadingIndicator />
          ) : (
            <Grid container direction="column" spacing={4}>
              <Grid item xs={12}>
                <Typography>
                  Are you sure you want to move this back to pending? Moving
                  this item will also remove it from the following content
                  groups:
                </Typography>
              </Grid>

              <List>
                {map(
                  parent => (
                    <ListItem key={parent.id}>
                      <ListItemText>{parent.name}</ListItemText>
                      <div className={classes.badge}>
                        <Typography className={classes.mediaType}>
                          {toUpper(parent.mediaType)}
                        </Typography>
                      </div>
                    </ListItem>
                  ),
                  parents,
                )}
              </List>
            </Grid>
          )
        }
        actionsClassName={classes.actions}
        actions={
          <Grid container alignItems="center">
            <Button
              variant="contained"
              onClick={removeParents}
              classes={{ root: classes.button }}
            >
              Remove File From Content Groups
            </Button>
            <Button onClick={handleCloseClick}>Cancel</Button>
          </Grid>
        }
      />
    </Fragment>
  );
};

export default PendingDialog;
